import { Backdrop, Box, Button, Card, CardActions, CardContent, CircularProgress, Divider, Modal, Typography, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { saveFotograf, base64Reader } from 'src/utils/storage/StrPhoto';
import CloseIcon from '@mui/icons-material/Close';


const styles = {
  root: (theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  }),
  actions: {
    justifyContent: 'flex-end'
  }
};

function FilePopup({ open, onClose, customer, FisNo, DosyaTipi, DosyaTipiText, uploadingFile,setUploadingFile, className, type = 0, ...rest }) {
  const [label, setLabel] = useState("Dosya seçiniz...");
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragActive, setIsDragActive] = useState(false);
  const fileInputRef = React.useRef(null);
  const MAX_FILE_SIZE = 50000000;
  const MAX_FILES = 5;

  if (!open) {
    return null;
  }

  const addSelectedFiles = (fileList) => {
    const incoming = Array.from(fileList || []);
    const validFiles = incoming.filter((file) => file.type.startsWith('image/') && file.size <= MAX_FILE_SIZE);
    if (validFiles.length > 0) {
      setSelectedFiles((prev) => [...prev, ...validFiles].slice(0, MAX_FILES));
    }
  };

  const handleDropFiles = (event) => {
    event.preventDefault();
    setIsDragActive(false);
    addSelectedFiles(event.dataTransfer.files);
  };

  const handleRemoveSelectedFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUploadClick = () => {
    if (selectedFiles.length === 0) {
      return;
    }
    const files = selectedFiles.map((file) => ({ file, meta: { name: file.name, type: file.type } }));
    const allFiles = selectedFiles.map(() => ({ remove: () => {} }));
    handleSubmit(files, allFiles);
    setSelectedFiles([]);
  };

  const handleSubmit = async (files, allFiles) => {
    if (!window.navigator.onLine) { // offline
      setLoading(true);
      files.forEach(f => {

        var reader = new FileReader()
        reader.onload = function (base64) {
          saveFotograf(FisNo, base64.target.result, DosyaTipi, f.meta.name, f.meta.type);
        };
        reader.readAsDataURL(f.file);
      });
      allFiles.forEach(f => f.remove());
      setLabel("Internet bağlantınız olmadığı için dosyalar cihazınıza kaydedildi. Merkeze Gönder aşamasında sisteme otomatik olarak yüklenecektir.");
      setLoading(false);
    } else {
      setLoading(true);
      var tempArray = uploadingFile;
      var Ids = uploadingFile.map(item => item.id);
      var maxId = Ids.length > 0 ? Math.max(...Ids) : 0;
      for (let i = 0; i < files.length; i++) {
        var fileMaterial = files[i].file;
        var metaMaterial = files[i].meta;
        let base64ResultMaterial = '';
        if (metaMaterial.type.indexOf('image') !== -1) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const image = new Image();
          image.src = URL.createObjectURL(fileMaterial);
          await new Promise((resolve, reject) => {
            image.onload = () => {
              const maxWidth = 1920;
              const maxHeight = 1920;
              let width = image.width;
              let height = image.height;
              if (width > maxWidth || height > maxHeight) {
                if (width / height > maxWidth / maxHeight) {
                  width = maxWidth;
                  height = Math.round(maxWidth * (image.height / image.width));
                } else {
                  height = maxHeight;
                  width = Math.round(maxHeight * (image.width / image.height));
                }
              }
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, 0, 0, width, height);
              base64ResultMaterial = canvas.toDataURL(metaMaterial.type, 1).split(',')[1];
              resolve();
            };
            image.onerror = reject;
          });
        } else {
          base64ResultMaterial = await base64Reader(fileMaterial);
        }

        const data = {

          Title: DosyaTipiText + ' - ' + metaMaterial.name,
          MIMEType: metaMaterial.type,
          ServiscePaperId: 0,
          DosyaTipi: DosyaTipi.toString(),
          FileData: base64ResultMaterial,
          type: type.toString(),
          FileUploadData:files[i]
        }
        tempArray = [...tempArray, data]
        // uploadFiles(data)
        setLoading(false)
        // setUploadFilePopUp(false)
      }
      setUploadingFile(tempArray);
      allFiles.forEach(f => f.remove())

    }


  }

  



  return (
    <Modal
      onClose={() => { setLabel("Dosya seçiniz..."); onClose() }}
      open={open}
    >
      <Card
        sx={styles.root}
        className={className}
      >
        <form>
          <CardContent color='secondary'>
            {
              loading ?
                <Backdrop sx={styles.backdrop} open={loading}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                : <>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    onChange={(event) => {
                      addSelectedFiles(event.target.files);
                      event.target.value = '';
                    }}
                  />
                  <Box
                    onClick={() => fileInputRef.current?.click()}
                    onDragOver={(event) => { event.preventDefault(); setIsDragActive(true); }}
                    onDragLeave={() => setIsDragActive(false)}
                    onDrop={handleDropFiles}
                    sx={{
                      minHeight: 200,
                      maxHeight: 250,
                      border: '2px dashed',
                      borderColor: isDragActive ? '#FF9800' : '#bdbdbd',
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      backgroundColor: isDragActive ? 'rgba(255,152,0,0.05)' : 'transparent',
                      transition: 'all 0.2s ease',
                      p: 2
                    }}
                  >
                    <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                      {selectedFiles.length > 0 ? `${5 - selectedFiles.length} ekle` : label}
                    </Typography>
                  </Box>
                  {selectedFiles.length > 0 && (
                    <List dense sx={{ mt: 1 }}>
                      {selectedFiles.map((file, index) => (
                        <ListItem key={index} disablepadding>
                          <ListItemText primary={file.name} />
                          <ListItemSecondaryAction>
                            <IconButton size="small" onClick={() => handleRemoveSelectedFile(index)}>
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                  )}
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{ mt: 1 }}
                    disabled={selectedFiles.length === 0}
                    onClick={handleUploadClick}
                  >
                    Yükle
                  </Button>
                </>
            }

          </CardContent>
          <Divider />
          <CardActions sx={styles.actions}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={() => { setLabel("Dosya seçiniz..."); onClose() }}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FilePopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default FilePopup;
